<div class="me-3">
  @if (comment.userContactPicturePath) {
    <img
      src="{{ this.apiUrl }}{{ comment.userContactPicturePath }}"
      class="userbox-img btn-rounded"
      />
    }
    @if (!comment.userContactPicturePath) {
      @if (currentAvatar$ | async; as avatar) {
        <img
        src="{{ avatar.url }}?name={{ avatar.contactName }}&bgColor={{
          avatar.bgColor
        }}&color=FFFFFF"
          alt="{{ avatar.contactName }}"
          class="userbox-img"
          />
        }
      }
    </div>
    <div class="d-flex flex-column">
      <div>
        <span class="font-weight-bolder pe-1">{{ comment.userContactName }}</span>
        <!--    <small>{{ {localeDate: comment.localeCreationDate, utcDate: comment.creationDate} | friendlyDate }}</small>-->
        <small>{{ comment.localeCreationDate | date : "dd/MM/yyyy HH:mm" }}</small>
      </div>
      <div class="text-break">{{ comment.message }}</div>
    </div>
